var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3092 1.05078C1.96351 0.71647 1.40476 0.71647 1.05907 1.05078C0.713383 1.3851 0.713383 1.92547 1.05907 2.25979L3.46561 4.58716L1.05907 6.91368C0.713383 7.24799 0.713383 7.78922 1.05907 8.12268C1.40476 8.45699 1.96351 8.45699 2.3092 8.12268L5.34081 5.19166C5.51321 5.02408 5.59985 4.80604 5.59985 4.58716C5.59985 4.36827 5.51321 4.14939 5.34081 3.98266L2.3092 1.05078Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.f92be259.svg";
export { ForwardRef as ReactComponent };